export const toCurrencyZero = (number = 0, currency = "Rp ") => {
  if (!number) return `${currency}0`;

  if (typeof number === "number")
    return `${currency}${parseInt(number).toLocaleString("id-ID")}`;

  return `${currency}0`;
};
